<template>
  <page-wrapper :title="title" :has-pad="true">
    <div class="wrapper">
      <package-category-editor
        v-model="form"
        :icon-url="iconUrl"
        :disabled="$isCallCenter"
      ></package-category-editor>
      <div v-if="!$isCallCenter" class="text-end">
        <sc-button
          :disabled="isSaving"
          variant="primary"
          @click="handleClickSave"
        >บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>

import { baanRueJaiClient } from "@/dependencies";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";

import PackageCategoryEditor from "../components/PackageCategoryEditor";
import iconPreviewMixin from "../mixins/iconPreviewMixin";
import categorySaveMixin from "../mixins/categorySaveMixin";
import { buildCategoryParams } from "../models/categoryParams";

export default {
  components: {
    PageWrapper,
    ScButton,
    PackageCategoryEditor
  },
  mixins: [iconPreviewMixin, categorySaveMixin],
  data() {
    const title = "เพิ่มหมวดหมู่";
    const form = {
      name: "",
      packages: [],
      iconFile: null
    };

    return {
      title,
      form
    };
  },
  methods: {
    async save() {
      const params = await buildCategoryParams(this.form);

      const response = await baanRueJaiClient.admin.ruejaiClub.categories.post(
        params
      );

      return response.data.result;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.editor {
  margin-bottom: $space;
}
</style>
